import { HolidayModel } from '../models/holiday.model';

/**
 * Obtener el numero de dias entre dos fechas
 * @param startDate string
 * @param endDate string
 * @returns number
 */
export const getNumberOfDays = (startDate: string, endDate: string) => {
    var start = new Date(startDate).getTime();
    var end = new Date(endDate).getTime();

    var diff = (end - start) / 86400000;

    if (diff > 30) {
        return 30;
    } else {
        return diff;
    }
};

/**
 * Obtener el día de la semana
 * @param fullDate string | number
 * @returns string
 */
export const getDayOfWeek = (fullDate: string | number) => {
    const daysOFWeek = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

    let date = new Date(fullDate);

    return daysOFWeek[date.getUTCDay()];
};

/**
 * Obtener el mes
 * @param month string
 * @returns string
 */
export const getMonth = (month: string) => {
    let date = new Date(month);

    const months = [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    return months[date.getUTCMonth()];
};

/**
 * Obtener un listado de fechas dentro de un rango
 * @param initDate string
 * @param endDate string
 * @returns string[]
 */
export const getDatesBetweenDates = (initDate: string, endDate: string) => {
    let listOfDates: string[] = [];

    let days = getNumberOfDays(initDate, endDate);

    let startDate = new Date(initDate);

    for (let index = 0; index <= days; index++) {
        let month = startDate.toISOString().split('T')[0].split('-')[1];
        let day = startDate.toISOString().split('T')[0].split('-')[2];

        listOfDates.push(`${startDate.getUTCFullYear()}-${month}-${day}`);
        startDate.setDate(startDate.getDate() + 1);
    }
    return listOfDates;
};

/**
 * Formateamos la fecha
 * @param fullDate string | number
 * @returns string
 */
export const formatShowDate = (fullDate: string | number) => {
    let day: string =
        '\n' + `\n ${getDayOfWeek(fullDate)}-${fullDate.toString().split('-')[2]} `;

    return day;
};

/**
 * Formateamos la fecha
 * @param date  string | undefined | number
 * @returns string
 */
export const formatDate = (date: string | undefined | number) => {
    if (date === undefined) {
        return '';
    } else {
        const result = date
            ?.toString()
            ?.split('-')
            .map((date) =>
                Number(date) < 10 && date.length === 1 ? '0' + date : date
            );

        return result?.join('-');
    }
};

/**
 * Validamos si la fecha es mayor o menor
 * @param selectedDate string
 * @param parameter number
 * @returns boolean
 */
export const compareTwoDates = (selectedDate: string, parameter: number) => {
    const today = new Date();
    const minimumDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - parameter);
    
    const [year, month, day] = selectedDate.split('-').map(Number);
    const actualDate = new Date(year, month - 1, day); 
    
    return actualDate < minimumDate;
};


/**
 * Mostramos la fecha
 * @param date string | undefined
 * @returns string
 */
export const showDateInfo = (date: string | undefined = '') => {
    let day = new Date(date);
    return day.toLocaleString();
};

/**
 * Obtenemos los dias festivos
 * @param date String
 * @param holidaysList HolidayModel[]
 * @returns  HolidayModel | undefined
 */
export const getHolidayDay = (date: String, holidaysList: HolidayModel[]) => {
    let resultHoliday = holidaysList?.find((h) => h.date.split('T')[0] == date);

    return resultHoliday;
};

/**
 * Formateamos la hora
 * @param hour string
 * @returns string
 */
export const formatHour = (hour: string) => {
    if (hour.length === 1) {
        return '0' + hour;
    }
    return hour;
};

/**
 * Formateamos la hora en formato de 24 horas
 * @param hourFormat string
 * @returns string
 */
export const covertFormatHour = (hourFormat: string) => {
    let hours = hourFormat.split(' ')[0];

    let hour = formatHour(hours.split(':')[0]);
    let minutes = hours.split(':')[1];
    let hourTime = hourFormat.split(' ')[1];

    minutes = minutes + ':00';

    if (hourTime == 'pm' || hourTime == 'p. m.') {
        switch (hour) {
            case '01':
                return '13:' + minutes;

            case '02':
                return '14:' + minutes;

            case '03':
                return '15:' + minutes;

            case '04':
                return '16:' + minutes;

            case '05':
                return '17:' + minutes;

            case '06':
                return '18:' + minutes;

            case '07':
                return '19:' + minutes;

            case '08':
                return '20:' + minutes;

            case '09':
                return '21:' + minutes;

            case '10':
                return '22:' + minutes;

            case '11':
                return '23:' + minutes;

            case '12':
                return '12:' + minutes;

            default:
                return hour + ':' + minutes;
        }
    } else {
        return hour + ':' + minutes;
    }
};

/**
 * Obtenemos las horas que hay entre un reango de fechas
 * @param startDate string
 * @param date1 string
 * @param date2 string
 * @returns string | number
 */
export const hanlderGetHours = (startDate: string, date1: string, date2: string) => {
    let dates1 = new Date(startDate + 'T' + date1);
    let dates2 = new Date(startDate + 'T' + date2);

    let diff = (dates2.getTime() - dates1.getTime()) / 1000;

    diff = diff / 60;

    if (Math.abs(diff / 60).toString().length > 1) {
        return Math.abs(diff / 60).toFixed(3);
    } else {
        return Math.abs(diff / 60);
    }
};

/**
 * Guardamos la hora en el estado que pasamos en las props
 * @param date  Date[]
 * @param setDate (date: string) => void
 */
export const handlerSetTime = (date: Date[], setDate: (date: string) => void) => {
    let formatDate = covertFormatHour(date[0].toLocaleString().split(', ')[1]);
    setDate(date[0].toString().split(' ')[4]);
};

/**
 * Formatea la fecha
 * @param date Date
 * @returns string
 */
export const handlerFormatDate = (date: Date) => {
    return (
        date.getFullYear() +
        '-' +
        formatHour((date.getMonth() + 1).toString()) +
        '-' +
        formatHour(date.getUTCDate().toString())
    );
};
